var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "19px",
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "00E37512-11CD-4F74-B786-DCE8367F4B23SVG/") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Office-Banking-factoring",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7-copy-16",
    transform: "translate(-486.000000, -108.000000)",
    fill: "#EC0000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B.-Digital,--Tech-&-Docs/e.-Arrows/BE171-arrow-left-2px-|-SYMBOLS,-arrow,-left,-flecha,-izquierda",
    transform: "translate(486.500000, 108.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.56395708,3.40273378 C8.87080708,3.71419682 8.8670625,4.21543503 8.55559708,4.52228503 L4.30660333,8.70833336 L16.625,8.70833336 C17.0622375,8.70833336 17.4166667,9.06277836 17.4166667,9.50000003 C17.4166667,9.93722169 17.0622375,10.2916667 16.625,10.2916667 L4.30660333,10.2916667 L8.55559708,14.4776834 C8.8670625,14.7845334 8.87080708,15.2858167 8.56395708,15.5972584 C8.25710708,15.9087 7.75586333,15.9125 7.44439792,15.60565 L1.81940042,10.0639517 C1.668371,9.91516586 1.58333333,9.71200836 1.58333333,9.50000003 C1.58333333,9.28799169 1.668371,9.08483419 1.81940042,8.93604836 L7.44439792,3.39437853 C7.75586333,3.08752948 8.25710708,3.09127002 8.56395708,3.40273378 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBackIcon);
export default __webpack_public_path__ + "static/media/go-back-icon.73efc397fc85c516a377084785c06744.svg";
export { ForwardRef as ReactComponent };